<script>
    import {previewUrlForCategory} from "./services/imageService";
    import {update_category} from "./Utils/RouterUtils.svelte";
    import DiffilcultyBadge from "./DiffilcultyBadge.svelte";
    import {fade} from 'svelte/transition';
    import CardTitle from "./CardTitle.svelte";
    import CardBody from "./CardBody.svelte";
    import CardDescription from "./CardDescription.svelte";
    import CardImage from "./CardImage.svelte";

    export let category = null;
  

    function backtotop() {
        let section = document.getElementById('tutorialBrowserTop');
        let sectionTop = section.offsetTop;
        window.scrollTo({
            top: sectionTop,
            behavior: "smooth"
        });
    }
</script>


<div
        id={category.slug.current}
        class="vec-flex vec-flex-col vec-space-y-4"
        in:fade="{{delay: 200,  duration: 700}}"
        on:click={update_category(category.slug.current), backtotop}>
    <CardImage src="{previewUrlForCategory(category)}" alt="{category.title}"></CardImage>
    <CardBody>
        <CardTitle>{category.title}</CardTitle>
        <DiffilcultyBadge difficulty={category.difficulty}/>
        <CardDescription>{category.description}</CardDescription>
    </CardBody>
</div>
